// This file is created to communicate view restricted state to amplitude.
// Because we do not have assignment till 3rd view, and it's done via ajax
// request, the value of view restricted state is not available right away
//
// So it has to be stored in a promise, and then sent to amplitude whenever we have it
//
// But we do not have proper code-splitting setup, so this file included in one pack, is not the same
// as in the other pack, as the result I have to setup state on window object, that independent of webpack we use

if (window._viewRestrictState === undefined) {
  window._viewRestrictState = {};
}
// Temporary resolve function, that calls itself.
if (window._viewRestrictState.resolve === undefined) {
  window._viewRestrictState.resolve = function (value) {
    setTimeout(function () {
      window._viewRestrictState.resolve(value);
    }, 0);
  };
}
if (window._viewRestrictState.promise === undefined) {
  window._viewRestrictState.promise = new Promise(
    (resolveF, _reject) => (window._viewRestrictState.resolve = resolveF)
  );
}

export const resolve = window._viewRestrictState.resolve;
const promise = window._viewRestrictState.promise;
export default promise;
